import { Alert, AlertDescription } from '@/components/ui/alert'
import { Trophy } from 'lucide-react'
import { PropsWithChildren } from 'react'

interface GameStatusAlertProps {
  status: 'won' | 'lost'
  children: PropsWithChildren['children']
}

export function GameStatusAlert({ status, children }: GameStatusAlertProps) {
  return (
    <Alert className={`${status === 'won' ? 'bg-primary text-primary-foreground animate-[celebrate_1s_ease-in-out]' : 'bg-secondary text-secondary-foreground'} mb-6 w-full max-w-xs sm:max-w-md mx-auto px-3 sm:px-4 overflow-hidden`}>
      <Trophy className={`h-4 w-4 flex-shrink-0 ${status === 'won' ? 'text-yellow-500 animate-[bounce_1s_ease-in-out_3]' : ''}`} />
      <AlertDescription className="text-sm text-primary-foreground break-words">
        {children}
      </AlertDescription>
    </Alert>
  )
}
